export let Action = /*#__PURE__*/function (Action) {
  Action["Click"] = "Click";
  Action["View"] = "View";
  return Action;
}({});
export let Applet = /*#__PURE__*/function (Applet) {
  Applet["Banking"] = "Banking";
  Applet["Settings"] = "Settings";
  return Applet;
}({});
export let Feature = /*#__PURE__*/function (Feature) {
  Feature["DebitCardLinking"] = "Debit Card Linking";
  return Feature;
}({});
export let Referrer = /*#__PURE__*/function (Referrer) {
  Referrer["BankLinking"] = "bank_linking_upsell";
  Referrer["TransferSettings"] = "transfer_settings";
  return Referrer;
}({});
export let Target = /*#__PURE__*/function (Target) {
  Target["Cancel"] = "Cancel";
  Target["CheckEmail"] = "Check Email";
  Target["Confirm"] = "Confirm";
  Target["DebitCardAdded"] = "Debit Card Added";
  Target["Error"] = "Error";
  Target["Screen"] = "Screen";
  Target["SuaRequired"] = "SUA Required";
  Target["SuaNotRequired"] = "SUA Not Required";
  Target["AzeAuth"] = "Aze Auth";
  Target["AzeUnauth"] = "Aze Unauth";
  return Target;
}({});
export let Page = /*#__PURE__*/function (Page) {
  Page["DebitCardAdded"] = "Debit Card Added";
  return Page;
}({});
const getEventName = (action, feature) => `${action} ${feature}`;
export function debitCardLinkingCdpEvent(args) {
  return {
    name: getEventName(args.action, Feature.DebitCardLinking),
    properties: {
      feature: Feature.DebitCardLinking,
      ...args
    }
  };
}